// F1: outbox-key resolution for the durable action-log outbox (useActionLogger).
//
// The B-2 durable outbox (batch_id/sequence/persistent retry) only engages when a truthy
// user id is passed to useActionLogger — it NAMESPACES the localStorage outbox + the
// per-session sequence counters by that id (shared-device quarantine). With no id the hook
// falls back to the legacy fire-and-forget best-effort branch, and telemetry can be lost.
//
// The Dashboard-built `studentProfile` (Dashboard.js) carries the authenticated user id as
// `student_id: String(currentUser.id)`; it has NO `user_id` field. The prior call site read
// `studentProfile?.user_id`, which was ALWAYS undefined for real students, so EVERY real
// student action silently took the legacy branch and the durable outbox never engaged.
//
// Resolve the outbox key from either field, preferring an explicit `user_id` when a caller
// supplies one (future-proofing) and otherwise accepting the always-present `student_id`
// (= the authenticated user id). Returns null only when neither is available (anonymous /
// pre-auth), which correctly keeps the hook on its best-effort branch.
export function resolveActionLoggerUserId(studentProfile) {
  if (!studentProfile) return null;
  return studentProfile.user_id ?? studentProfile.student_id ?? null;
}
